<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>{{ dialogTitle }}</h3>
    </template>
    <v-form ref="form">
      <div class="content">
        <v-textarea
          v-model="form.question"
          name="question"
          :label="$t('message.storeLocator.faq.question')"
          v-validate="'required|max-length:200'"
          rows="2"
          counter="200"
          no-resize
          :error-messages="errors.collect('question')"
        ></v-textarea>
        <v-textarea
          v-model="form.answer"
          name="answer"
          :label="$t('message.storeLocator.faq.answer')"
          rows="3"
          v-validate="'required|max-length:500'"
          counter="500"
          no-resize
          :error-messages="errors.collect('answer')"
        ></v-textarea>
      </div>
    </v-form>
    <template #actions>
      <div class="action-bar">
        <ui-button color="primary" @click="handleSubmit">
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "StoreLocatorFaqManageDialog",
  props: {
    editData: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        question: "",
        answer: ""
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.isEdit
        ? this.$t("message.storeLocator.faq.editTitle")
        : this.$t("message.storeLocator.faq.faqCreatorTitle");
    },
    isEdit() {
      return this.editData;
    }
  },
  created() {
    this.assignDefaultFormIfExists();
  },
  methods: {
    assignDefaultFormIfExists() {
      if (this.editData) {
        this.form.question = this.editData.question;
        this.form.answer = this.editData.answer;
      }
    },
    async handleSubmit() {
      const submitEvent = this.isEdit ? "update" : "create";
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.$emit(submitEvent, { ...this.form });
        this.$validator.reset();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep label,
::v-deep textarea {
  @include font-size(14px);
}
.action-bar {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
}
</style>
